import { render, staticRenderFns } from "./beforePayroll.vue?vue&type=template&id=381ccc23&scoped=true"
import script from "./beforePayroll.vue?vue&type=script&lang=js"
export * from "./beforePayroll.vue?vue&type=script&lang=js"
import style0 from "./beforePayroll.vue?vue&type=style&index=0&id=381ccc23&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "381ccc23",
  null
  
)

export default component.exports